import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@headlessui/react';
import { FormInput } from './FormInput';

interface DuplicateBudgetDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (name: string) => void;
  defaultName?: string;
}

export const DuplicateBudgetDialog: React.FC<DuplicateBudgetDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  defaultName = '',
}) => {
  const { t } = useTranslation();
  const [name, setName] = useState(defaultName);

  const handleConfirm = () => {
    if (name.trim()) {
      onConfirm(name);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} className="fixed inset-0 z-10 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center">
        <div
          className="fixed inset-0 bg-black bg-opacity-30 dark:bg-opacity-50"
          aria-hidden="true"
        />

        <div className="relative mx-4 w-full max-w-md rounded-lg bg-white p-8 dark:bg-surface-800">
          <Dialog.Title className="mb-4 text-lg font-medium text-slate-900 dark:text-white">
            {t('budget.duplicate')}
          </Dialog.Title>

          <form onSubmit={(e) => { e.preventDefault(); handleConfirm(); }} className="space-y-4">
            <FormInput
              label={t('budget.name')}
              value={name}
              onChange={(value) => setName(value as string)}
              placeholder={t('budget.name')}
            />

            <div className="flex justify-end space-x-3">
              <button
                type="button"
                onClick={onClose}
                className="rounded-md border border-slate-500 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:border-slate-500 dark:bg-surface-700 dark:text-slate-300 dark:hover:bg-surface-600"
              >
                {t('common.cancel')}
              </button>
              <button
                type="submit"
                data-attr="duplicate-budget-dialog-confirm-button"
                className="rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:bg-indigo-500 dark:text-white dark:hover:bg-indigo-400"
              >
                {t('common.confirm')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Dialog>
  );
};
